/**
 * @props progress: (number between 0-100) represents the progress in terms of percentage 
 * @props borderThickness: (number) thickness of the border of the circle
 * @props textSize: (size in pixels) size of the text shown in the center of the circle
 * @props textColor: (hex color code) color of the text shown in the center of the circle
 * @props progressBorderColor: (hex color code) color of the progress bar
 * @props width: (size in pixels) width of the circle
 */

import React from "react";

const CircularProgressBar = ({ progress = 0, borderThickness = 7, textSize = "28px", textColor = "#262626", progressBorderColor = "#215DAA", width = "60px" }) => {
    const size = 100;
    const strokeWidth = borderThickness; // Width of the progress bar stroke
    const radius = size / 2; // Radius of the progress circle
    const circumference = 2 * Math.PI * radius; // Circumference of the progress circle
    const progressOffset = circumference * (1 - progress / 100); // Offset of the progress bar based on the progress percentage

    return (
        <div style={{ width }}>
            <svg viewBox={`0 0 ${size} ${size}`}>
                <circle
                    cx={radius}
                    cy={radius}
                    r={radius - strokeWidth / 2}
                    fill="none"
                    stroke="#DBE1E9"
                    strokeWidth={strokeWidth}
                />
                <circle
                    cx={radius}
                    cy={radius}
                    r={radius - strokeWidth / 2}
                    fill="none"
                    stroke={progressBorderColor}
                    strokeWidth={strokeWidth}
                    strokeDasharray={circumference}
                    strokeDashoffset={progressOffset}
                    transform={`rotate(-90 ${radius} ${radius})`}
                    strokeLinecap="round"
                />
                <text
                    x="50%"
                    y="55%"
                    fill={textColor}
                    dominantBaseline="middle"
                    textAnchor="middle"
                    fontFamily="Lato"
                    fontStyle="normal"
                    fontWeight="600"
                    fontSize={textSize}
                >
                    {`${progress}%`}
                </text>
            </svg>
        </div>
    );
};

export default CircularProgressBar;